<div [ngClass]="{'stream-detail-box': !loading && stream}">

    <ion-item *ngIf="!loading"
              #streamBox>

        <ion-grid class="ion-no-padding"
                  tabIndex="-1">

            <ion-row class="header ion-no-padding"
                     tabIndex="-1">
                <ion-col class="ion-no-padding">
                    <strong>
                        {{ stream.title }}
                    </strong>
                </ion-col>
            </ion-row>

            <ion-row class="content ion-no-padding"
                     tabIndex="-1">
                <ion-col class="ion-no-padding">
                    <iframe *ngIf="stream.embed_link"
                            [src]="stream.embed_link | safe:'resourceUrl'"
                            frameborder="0"
                            allowfullscreen>
                    </iframe>

                    <span *ngIf="stream.display_chat && stream.chat_group"
                          class="link-unread pointer"
                          (click)="loadStream(stream)">
                        <svg-icon [applyClass]="true"
                                  src="/assets/icons/ico-messages.svg"
                                  class="fill-menu-contrast"></svg-icon>

                        <ion-badge *ngIf="stream.unread_messages_count"
                                   class="unread-count">
                            {{ stream.unread_messages_count }}
                        </ion-badge>
                    </span>

                </ion-col>
            </ion-row>

            <ion-row class="footer ion-no-padding"
                     tabIndex="-1">
                <ion-col class="ion-no-padding">
                    <ion-button (click)="loadStream(stream)">
                        {{ 'STREAM_BTN_DETAIL' | translate }}
                    </ion-button>
                </ion-col>
            </ion-row>

        </ion-grid>

    </ion-item>

    <ng-container *ngIf="loading">
        <div class="content-centered-column">
            <div class="content-centered-row">
                <ion-spinner></ion-spinner>
            </div>
        </div>
    </ng-container>
</div>